export default __webpack_public_path__ + "assets/EditOutline.cb94.svg";